<ng-container>
  <div class="filter-modal-header-container">
    <h2 [translate]="'SideFilterComponent:TitleSelectCategory'">Filter by Category</h2>
    <mat-icon (click)="closeModal()">close</mat-icon>
  </div>
  <div class="filter-modal-body-container" tabindex="0">
    <div class="leftColumn">
      <ng-container *ngTemplateOutlet="categoryList; context: { $implicit: { list: tagsInLeftColumn, side: 'left' } }">
      </ng-container>
    </div>
    <div class="rightColumn">
      <ng-container
        *ngTemplateOutlet="categoryList; context: { $implicit: { list: tagsInRightColumn, side: 'right' } }"
      >
      </ng-container>
    </div>
  </div>
  <div class="filter-modal-bottom-container">
    <button mat-raised-button tabindex="0" class="cancel-button" (click)="closeModal()">
      {{ 'ChatWindow:Cancel' | translate }}
    </button>
    <button
      mat-raised-button
      tabindex="0"
      color="primary"
      id="apply"
      class="submit-button"
      [disabled]="!numberOfAppliedFilterTags"
      (click)="onApplyFilters()"
    >
      <span>
        {{ 'MemberBenefitsSearchComponent:ApplyFilters' | translate: { number: numberOfAppliedFilterTags } }}
      </span>
    </button>
  </div>
</ng-container>

<ng-template #categoryList let-tags>
  <div *ngFor="let parentCategory of tags.list | parentTag; let i = index">
    <mat-checkbox
      tabindex="0"
      [(ngModel)]="parentCategory.selected"
      [checked]="parentCategory.selected"
      class="parent-category"
      (change)="onParentCategoryClick(parentCategory)"
      id="{{ i }}-{{ tags.side }}-macro-category"
      name="{{ i }}-{{ tags.side }}-macro-category"
      aria-label="{{ parentCategory.name }}"
      >{{ parentCategory.name }}
    </mat-checkbox>
    <div *ngFor="let subcategory of parentCategory.subcategories; let j = index">
      <mat-checkbox
        tabindex="0"
        [(ngModel)]="subcategory.selected"
        [checked]="subcategory.selected"
        (change)="onSubcategoryClick(subcategory, parentCategory)"
        id="{{ i }}-{{ tags.side }}-{{ j }}-subcategory"
        name="{{ i }}-{{ tags.side }}-{{ j }}-subcategory"
      >
        <span>{{ subcategory.name }}</span>
      </mat-checkbox>
    </div>
  </div>
</ng-template>
